ORDER_STATUSES   = ['pending', 'confirm', 'preparing', 'prepared', 'delivery']

initSelectedStatuses = ->
  selectedStatuses = ORDER_STATUSES.map (status) =>
    Em.Object.create
      name:  status
      label: "order.status.#{status}"
      checked: false

  Em.A(selectedStatuses)

App.SidebarOrdersFiltersComponent = Em.Component.extend
  env: Em.inject.service('environment')
  store: Em.inject.service('store')
  monitor: Em.inject.service('orderMonitor')

  classNames: ['sidebar-orders-filters']
  classNameBindings: ['filtersEnabled:show']

  filtersEnabled: false

  activeColor: false

  orders: []
  restaurants: []
  couriers: []
  deliveryZones: Ember.computed(->
    @get('store').find 'delivery-zone'
  )

  selectedCouriers:      []
  selectedRestaurants:   []
  selectedDeliveryZones: []
  selectedStatuses:  initSelectedStatuses()
  deliveryFrom: null
  deliveryTill: null

  deliveryFromOWBinding: Em.Binding.oneWay('deliveryFrom')
  deliveryTillOWBinding: Em.Binding.oneWay('deliveryTill')

  filteredOrders: []
  filtersText: (->
    filterData = [
      { key: 'selectedStatuses', label: Em.I18n.t 'orders.sidebar.filters.status' },
      { key: 'selectedRestaurants', label: Em.I18n.t 'orders.sidebar.filters.restaurant' },
      { key: 'selectedDeliveryZones', label: Em.I18n.t 'orders.sidebar.filters.zone' },
      { key: 'selectedCouriers', label: Em.I18n.t 'orders.sidebar.filters.courier' }
      { key: 'selectedDate', label: Em.I18n.t 'orders.sidebar.filters.date' }
    ]
    statuses = @get('selectedStatuses')
      .filter((s) -> s.checked)

    getFormattedItems = (items, key, label) =>
      text = items?.map (item) => item?.get('name')
      return '' if not text and key != 'selectedDate'
      if(key == 'selectedDate')
        deliveryAtTill =  moment(@get('deliveryTillOW') or @get('deliveryFromOW'))
        deliveryAtFrom =  moment(@get('deliveryFromOW') or @get('deliveryTillOW'))
        text = [deliveryAtFrom.format('DD.MM.YYYY'), deliveryAtTill.format('DD.MM.YYYY')]
        return unless deliveryAtTill.isValid() and deliveryAtFrom.isValid() then '' else "#{label}#{text.join(" #{Em.I18n.t 'orders.sidebar.sections.separator'} ")}"
      if(key == 'selectedStatuses')
        text = text.map (status) => 
          Em.I18n.t "order.status.#{status}"
  
      "#{label}#{text.join(', ')}"


    filterTextParts = (filterData
      .map (data) =>
        items = if data.key == 'selectedStatuses' then statuses else @get(data.key) 
        if items?.length > 0 or data.key == 'selectedDate'
          "#{getFormattedItems(items, data.key, data.label)}"
        else
          null
      )
      .filter (text) => text
    @set('activeColor', filterTextParts.length > 0)
    return Em.I18n.t 'orders.sidebar.filters.zeroData' unless filterTextParts.length
    resultText = filterTextParts.join(' ● ')
    if resultText.length >= 100 then "#{resultText.slice(0,100)}... #{Em.I18n.t 'orders.sidebar.filters.elepsis'}" else resultText

  ).property('filtersEnabled', 'selectedCouriers', 'selectedRestaurants', 'selectedDeliveryZones', 'selectedStatuses')

  actions:
    showFilters: (->
      @set('filtersEnabled', true)
    )
    
    applyFilters: (->
      @set('filtersEnabled', false)
      Em.run.next =>
        courierIds    = @get('selectedCouriers').map (c) => Em.get(c, 'id')
        restaurantIds = @get('selectedRestaurants').map (r) => Em.get(r, 'id')
        deliveryZonesIds = @get('selectedDeliveryZones').map (r) => Em.get(r, 'id')
        order_status = @get('selectedStatuses')
          .filter((s) -> s.checked)
          .map((s) -> s.name)
          .toArray()
        deliveryAtTill =  moment(@get('deliveryTillOW') or @get('deliveryFromOW'))
        deliveryAtFrom =  moment(@get('deliveryFromOW') or @get('deliveryTillOW'))
        
          
        result = Em.ArrayProxy.createWithMixins Em.ArrangeableMixin,
          content: @get('orders.content')
          sortProperties: [ 'orderMapSortWeight', 'delivery_at', 'id' ]
          sortAscending: false
          filterProperties: [
            [ 'status',   (k, v) -> if order_status.length > 0 then v in order_status else v ]
            [ 'courier',  (k, v) -> if courierIds.length > 0 then v.get('id') in courierIds else v]
            [ 'delivery_zone',   (k, v) -> if deliveryZonesIds.length > 0 then v.get('id') in deliveryZonesIds else v ]
            [ 'restaurant',  (k, v) -> if restaurantIds.length > 0 then v.get('id') in restaurantIds else v ]
            [ 'delivery_at', (k, v) -> 

              if deliveryAtTill.isValid() or deliveryAtTill.isValid()
                moment(v).isBetween(deliveryAtFrom, deliveryAtTill)
              else v
            ]
          ]
        @set('orders', result)
    )
